var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#079D49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9718 13.2507C24.0048 12.7127 22.7867 13.0627 22.2517 14.0277L18.5387 20.7097L16.4137 18.5847C15.6327 17.8037 14.3668 17.8037 13.5857 18.5847C12.8047 19.3657 12.8047 20.6317 13.5857 21.4127L17.5858 25.4127C17.9638 25.7917 18.4738 25.9997 18.9998 25.9997L19.2768 25.9797C19.8978 25.8927 20.4428 25.5197 20.7478 24.9707L25.7477 15.9707C26.2847 15.0047 25.9368 13.7877 24.9718 13.2507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleCheck);
export default __webpack_public_path__ + "static/media/green-circle-check.92df7a6bd6df6c60bb956bcda0198031.svg";
export { ForwardRef as ReactComponent };